import cartRoutes from 'bento-ordering/cart/routes';
import locationRoutes from 'bento-ordering/locations/routes';
import menuRoutes from 'bento-ordering/menus/routes';

const routes = [...cartRoutes, ...locationRoutes, ...menuRoutes];

export default routes;
